// Components
import { TagName } from "components/TagName";
import NavButton from "components/HeaderNavigation/NavButton";
import { Card, CardContent, Box, Typography, Skeleton } from "@mui/material";

// Hooks
import useAuth from "utils/hooks/useAuth";
import { FormattedMessage } from "react-intl";
import useChooseYourHub from "./useChooseYourHub";

// Styles
import useStyles from "./ChooseYourHub.styles";
import { getRoleName } from "./adapters/converters";

const ChooseYourHub = () => {
    const classes = useStyles();
    const { sessionData } = useAuth();

    const { userOrgs, updateSelectedOrg } = useChooseYourHub();

    return (
        <Box className={classes.mainWrapper}>
            <Card className={classes.cardContainer}>
                <CardContent>
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="chooseYourHub.welcome"
                            values={{ userName: sessionData?.authn.user.name }}
                        />
                    </Typography>
                    <Box mb={3}>
                        <Typography className={classes.subtitle}>
                            <FormattedMessage id="chooseYourHub.chooseYourHub" />
                        </Typography>
                        <Typography className={classes.intro} paragraph>
                            <FormattedMessage id="chooseYourHub.intro" />
                        </Typography>
                    </Box>
                    {userOrgs.data.map((hub) => (
                        <Box key={hub.id} className={classes.hub}>
                            <Box>
                                <TagName>{hub.name}</TagName>
                                <Box sx={{ mt: 1 }}>
                                    <span>
                                        <FormattedMessage id="chooseYourHub.ldPermission" />:
                                    </span>{" "}
                                    {getRoleName(hub, "IS_LD")?.label} |{" "}
                                    <span>
                                        <FormattedMessage id="chooseYourHub.pacePermission" />:
                                    </span>{" "}
                                    {getRoleName(hub, "IS_PACE")?.label}
                                </Box>
                            </Box>
                            <NavButton
                                icon={null}
                                showBackArrow={false}
                                onClick={() => updateSelectedOrg(hub.id)}
                                translationId="chooseYourHub.enter"
                            />
                        </Box>
                    ))}
                    {userOrgs.status === "fetching" &&
                        Array.from(Array(3)).map((_, i) => <Skeleton animation="wave" height={47} key={i} />)}
                </CardContent>
            </Card>
        </Box>
    );
};

export default ChooseYourHub;
